import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _7kPlusIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"7k_plus"} ref={ref}/>
});

_7kPlusIcon.displayName = "_7kPlusIcon";
